import { KeyboardEvent, useCallback } from 'react';
import { TextField } from '@mui/material';
import { sharedColors } from '../../utils/Style';

type FilterSearchBoxProps<T> = {
  label: string;
  filters: T;
  onChange: (newFilters: T) => void;
  fieldName: keyof T;
  onEnter: () => void;
};

export const FilterSearchBox = <T extends object>(
  props: FilterSearchBoxProps<T>,
) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        props.onEnter();
      }
    },
    [props.onEnter],
  );

  return (
    <TextField
      size='small'
      label={props.label}
      value={props.filters[props.fieldName] ?? ''}
      onChange={(e) =>
        props.onChange({
          ...props.filters,
          [props.fieldName]: e.target.value,
        })
      }
      onKeyDown={handleKeyDown}
      sx={{
        minWidth: 250,
        maxWidth: 500,
        flexGrow: 1,
        backgroundColor: sharedColors.white,
        height: 'fit-content',
      }}
    />
  );
};
